import React, { useContext } from 'react'
import { ThemeContext } from 'f-web-app'

export default function NextButtonView({ isCheckingEmail }) {
  const { Components } = useContext(ThemeContext)
  return <Components.PaintedButtonView disabled={isCheckingEmail} label={isCheckingEmail ? 'CHECKING...' : 'NEXT'} />
}
